// extracted by mini-css-extract-plugin
export default {"contentContainer":"CreateContent_contentContainer__ykRs1","calculateBtnContainer":"CreateContent_calculateBtnContainer__-yWCv"};